export const iconFontAwesomeAlertSkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
